var map = {
	"./1.png": 81976,
	"./2.png": 56467,
	"./3.png": 5706,
	"./4.png": 90373,
	"./a.png": 55560,
	"./a2.png": 33480,
	"./arrow-next.png": 1690,
	"./arrow-prev.png": 41458,
	"./bg-bottom-wave.png": 13178,
	"./bg-md.png": 55648,
	"./bg-top-wave.png": 48690,
	"./bg.png": 10116,
	"./logo_w.svg": 48166,
	"./mobile.png": 97599,
	"./pm1.png": 70779,
	"./pm2.png": 92448,
	"./pm3.png": 47273,
	"./pmain.png": 25942,
	"./pq1.png": 67199,
	"./pq2.png": 12548,
	"./pq3.png": 52493,
	"./pq4.png": 79986,
	"./promo.png": 8512,
	"./pw1.png": 37993,
	"./pw2.png": 72850,
	"./pw3.png": 21851,
	"./pw4.png": 11908,
	"./r1.png": 93746,
	"./r2.png": 41929,
	"./r3.png": 17728,
	"./r4.png": 45759,
	"./slogo.svg": 61853,
	"./top-xs.png": 77848,
	"./win.png": 70487,
	"pages/promo/assets/img/promo6/1.png": 81976,
	"pages/promo/assets/img/promo6/2.png": 56467,
	"pages/promo/assets/img/promo6/3.png": 5706,
	"pages/promo/assets/img/promo6/4.png": 90373,
	"pages/promo/assets/img/promo6/a.png": 55560,
	"pages/promo/assets/img/promo6/a2.png": 33480,
	"pages/promo/assets/img/promo6/arrow-next.png": 1690,
	"pages/promo/assets/img/promo6/arrow-prev.png": 41458,
	"pages/promo/assets/img/promo6/bg-bottom-wave.png": 13178,
	"pages/promo/assets/img/promo6/bg-md.png": 55648,
	"pages/promo/assets/img/promo6/bg-top-wave.png": 48690,
	"pages/promo/assets/img/promo6/bg.png": 10116,
	"pages/promo/assets/img/promo6/logo_w.svg": 48166,
	"pages/promo/assets/img/promo6/mobile.png": 97599,
	"pages/promo/assets/img/promo6/pm1.png": 70779,
	"pages/promo/assets/img/promo6/pm2.png": 92448,
	"pages/promo/assets/img/promo6/pm3.png": 47273,
	"pages/promo/assets/img/promo6/pmain.png": 25942,
	"pages/promo/assets/img/promo6/pq1.png": 67199,
	"pages/promo/assets/img/promo6/pq2.png": 12548,
	"pages/promo/assets/img/promo6/pq3.png": 52493,
	"pages/promo/assets/img/promo6/pq4.png": 79986,
	"pages/promo/assets/img/promo6/promo.png": 8512,
	"pages/promo/assets/img/promo6/pw1.png": 37993,
	"pages/promo/assets/img/promo6/pw2.png": 72850,
	"pages/promo/assets/img/promo6/pw3.png": 21851,
	"pages/promo/assets/img/promo6/pw4.png": 11908,
	"pages/promo/assets/img/promo6/r1.png": 93746,
	"pages/promo/assets/img/promo6/r2.png": 41929,
	"pages/promo/assets/img/promo6/r3.png": 17728,
	"pages/promo/assets/img/promo6/r4.png": 45759,
	"pages/promo/assets/img/promo6/slogo.svg": 61853,
	"pages/promo/assets/img/promo6/top-xs.png": 77848,
	"pages/promo/assets/img/promo6/win.png": 70487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23806;